import { useContext } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { CountryContext } from 'CountryContext';
import { IMAGES } from 'common/images';
import { COUNTRIES, PERSONAS } from 'common/constants';
import { LINKS } from 'navigation/constants';
import { Fade } from 'components/Fade';
import { DATA } from 'components/Superpowers/constants';
import 'components/Superpowers/index.scss';

export const Superpowers = ({ type }) => {
  const { country } = useContext(CountryContext);

  const renderPrices = () => {
    if (country !== COUNTRIES.INDIA) {
      return <div />;
    }

    let cost = '₹149';
    let subtitle = 'per month/per card';
    let plan = '';

    if (type === PERSONAS.PARENT) {
      plan = 'Freedom Plan';
      cost = '₹1499';
      subtitle = 'per year, upto 3 cards';
    }

    return (
      <div>
        {plan && <p className="superpowers__freedom">{plan}</p>}
        <p className="superpowers__amount">{cost}</p>
        <p className="superpowers__amount__card">{subtitle}</p>
      </div>
    );
  };

  return (
    <Row className="superpowers text-center justify-content-center">
      <Col className="max-width-container">
        {type === PERSONAS.PARENT && <div className="helper" />}
        <Fade>
          <p className="superpowers__title">
            {type === PERSONAS.PARENT ? 'Supercharge Money' : 'Unlock your superpower'}
          </p>
          <p className="superpowers__available">
            {country === COUNTRIES.INDIA ? 'Available on:' : 'Launching Soon'}
          </p>
          {country === COUNTRIES.INDIA ? (
            <>
              <a target="_blank" rel="noopener" href={LINKS.PLAYSTORE}>
                <Image src={IMAGES.PlayStore} alt="Play Store"className="superpowers__store" />
              </a>
              <a target="_blank" rel="noopener" href={LINKS.APPSTORE}>
                <Image src={IMAGES.AppStore} alt="App Store"className="superpowers__store" />
              </a>
            </>
          ) : (
            <>
              <Image src={IMAGES.PlayStore} alt="Play Store"className="superpowers__store" />
              <Image src={IMAGES.AppStore} alt="App Store"className="superpowers__store" />
            </>
          )}
          <Row className="justify-content-center">
            <div className="superpowers__divider" />
          </Row>
          {renderPrices()}
          <p className="superpowers__value">
            <em>Infinite</em> value, and costs less than:
          </p>
          <Row className="justify-content-center superpowers__row">
            {DATA[type].map((item) => (
              <Col key={item.key} xs={12} md={3} className="no-pad superpowers__col">
                <Image src={item.icon} alt="icon for superpower" className="superpower-card__icon" />
                <p className="superpower-card__title">{item.title}</p>
              </Col>
            ))}
          </Row>
        </Fade>
      </Col>
    </Row>
  );
};
